import {
  TiSocialFacebook,
  TiSocialTwitter,
  TiSocialLinkedin,
  TiRss,
} from "react-icons/ti";
export const footerLinks = [
  {
    infoLink: "home",
    linkName: "Home",
  },
  {
    infoLink: "about",
    linkName: "About",
  },
  {
    infoLink: "services",
    linkName: "Doctors",
  },
  {
    infoLink: "doctors",
    linkName: "Doctors",
  },
  {
    infoLink: "partners",
    linkName: "Partners",
  },
  {
    infoLink: "testimonials",
    linkName: "Testimonials",
  },
  {
    infoLink: "contact",
    linkName: "Contact",
  },
];

export const footerIcons = [
  {
    id: 1,
    icon: <TiSocialFacebook />,
  },
  {
    id: 1,
    icon: <TiSocialTwitter />,
  },
  {
    id: 1,
    icon: <TiSocialLinkedin />,
  },
  {
    id: 1,
    icon: <TiRss />,
  },
];
